import React, { useEffect, useMemo, useState } from 'react';

import MenuItemDropdown, { MenuItemLink } from './MenuItem';
import MenuList from './MenuList';

import config from 'appconfig';
import { useSelector } from 'react-redux';
import { State } from 'model/State';
import { selectGetCustomerByEmailSuccess, selectSwitchedUser } from 'modules/mac/duck/selectors';

const topMenuItemsSC = [
  {
    Component: MenuItemDropdown,
    menuKey: 'products',
    text: 'navigation.header.products',
  },
  {
    Component: MenuItemDropdown,
    menuKey: 'teams',
    text: 'navigation.header.teams',
  },
  {
    Component: MenuItemDropdown,
    menuKey: 'support',
    text: 'navigation.header.support',
  },
  {
    Component: MenuItemLink,
    href: `${config.wacUrl}/try`,
    text: 'navigation.header.try',
  },
  {
    Component: MenuItemLink,
    href: `${config.root}`,
    text: 'navigation.header.buy',
  },
];

const topMenuItemsMAC = [
  {
    Component: MenuItemLink,
    href: `${config.root}/my`,
    text: 'navigation.header.licenses',
  },
  {
    Component: MenuItemLink,
    href: `${config.wacUrl}/download`,
    text: 'navigation.header.downloads',
  },
  {
    Component: MenuItemLink,
    href: `${config.root}/my/billing/quotes`,
    text: 'navigation.header.orders',
  },
  {
    Component: MenuItemLink,
    href: `${config.root}`,
    text: 'navigation.header.buy',
  },
];

const topMenuItemsMACPartners = [
  {
    Component: MenuItemLink,
    href: `${config.root}/my`,
    text: 'navigation.header.licenses',
  },
  {
    Component: MenuItemLink,
    href: `${config.wacUrl}/download`,
    text: 'navigation.header.downloads',
  },
  {
    Component: MenuItemLink,
    href: `${config.root}/my/billing/quotes`,
    text: 'navigation.header.orders',
  },
  {
    Component: MenuItemLink,
    href: `${config.root}`,
    text: 'navigation.header.buy',
  },
  {
    Component: MenuItemLink,
    href: `${config.root}/my/customers/partner`,
    text: 'navigation.header.partners',
  },
];

type TopMenuItemType = {
  Component: React.FC<any>;
  href?: string;
  text: string;
};

type PropTypes = {
  isMACPage: boolean;
};

const TopMenu: React.FC<PropTypes> = React.memo(({ isMACPage }) => {
  const [isPartner, setIsPartner] = useState(false);
  const switchedUserEmail = useSelector(selectSwitchedUser);
  const location = useSelector((state: State) => state.location);

  const customerBySwitchedUserEmail = useSelector((state: State) =>
    selectGetCustomerByEmailSuccess(state, switchedUserEmail),
  );

  useEffect(() => {
    if (customerBySwitchedUserEmail?.organisationDetails) {
      setIsPartner(customerBySwitchedUserEmail?.organisationDetails?.expert);
    }
  }, [isMACPage, customerBySwitchedUserEmail, switchedUserEmail]);

  const topMenuItems: TopMenuItemType[] = useMemo(() => {
    let menuItems;

    if (isMACPage && !isPartner) {
      menuItems = topMenuItemsMAC;
    } else if (isMACPage && isPartner) {
      menuItems = topMenuItemsMACPartners;
    } else {
      menuItems = topMenuItemsSC;
    }
    return menuItems;
  }, [isMACPage, isPartner]);

  const isActive = (pathname: string | undefined) => {
    if (!pathname) return false;

    const url = new URL(pathname);
    const route = url.pathname.replace('/purchase', '');

    return location.pathname === '/my/billing/quotes'
      ? route === '/my/billing/quotes'
      : route === location.pathname;
  };

  return (
    <MenuList isMACPage={isMACPage}>
      {topMenuItems.map((item) => {
        const { Component, ...props } = item;

        return <Component key={props.text} active={isMACPage && isActive(props.href)} {...props} />;
      })}
    </MenuList>
  );
});

export default TopMenu;
